SC.promotion = (function () {
  var init = function () {
    setupEvents();
  };

  function setupEvents() {
    var checkoutBtn = document.getElementById('promo-checkout-btn');
    var promoData = JSON.parse(document.getElementById('promotion-offer-data').dataset.promotion);

    function checkoutCallback() {
      window.location.href = '/promotion/' + promoData.id + '/checkout/';
    }

    function handleCheckoutClick() {
      checkoutCallback();
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', handleCheckoutClick);
    }
  }

  init();
})();
